import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@coworker/http-client";
import { CustomLocationsResult } from "../types/customLocationsResultType";
import { TaskType } from "../enums/taskTypes";

async function fetchRecentCustomLocationsForItem(
  itemNo: string,
  taskType: TaskType
) {
  return await httpClient.tasks.get<CustomLocationsResult>(
    "/v1/locations/custom/item",
    { params: { itemNo, taskType } }
  );
}

export function useRecentCustomLocationsForItem(
  itemNo: string,
  taskType: TaskType
) {
  return useQuery({
    enabled: !!itemNo,
    queryKey: ["customlocations", "item", itemNo, taskType],
    queryFn: async () =>
      await fetchRecentCustomLocationsForItem(itemNo, taskType),
    staleTime: 0,
  });
}
